import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";
import { errorMembershipRoute } from "../../error/PageMembershipStatusError/route";
export const traineesRoute: RouteConfig<'with-page'> = {
    name: 'Trainees',
    page: lazy(() => import('.')),
    path: '/training/trainees',
    flags: ['member-route'],
    permissions: ['training'],
    permissionsRedirect: errorMembershipRoute,
    context:'member'
}